import { toKebabCase } from '@jbhi-fi/utils/src/toKebabCase';

export type TrackingData = {
  id: string;
  url?: string;
  campaign?: string;
  category?: 'homepage' | string;
  type?: 'carousel' | 'leaderboard' | string;
  position?: number;
  isBranded?: boolean;
};

export const trackingDataToDataAttributes = (trackingData: TrackingData | undefined) => {
  if (!trackingData) return {};
  return {
    'data-gaip': 'true',
    ...Object.entries(trackingData).reduce(
      (acc, [key, value]) => ({ ...acc, [`data-gaip-${toKebabCase(key)}`]: value?.toString() ?? '' }),
      {}
    ),
    'data-gaip-has-onclick': !!trackingData?.url,
  };
};
